import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
export default function TransactionMenu() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": "action-menu",
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": "resident menu",
    className: classes.transactionDropdown,
    id: "action-menu-trigger",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    variant: "actionButton",
    'custom-attribute': '781-reporting-page-transaction-menu'
  }, /*#__PURE__*/React.createElement("span", null, t('reporting.options')), /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    elevation: 0,
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    onClose: handleClose,
    open: open,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    type: "action-menu"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    'custom-attribute': '782-reporting-page-transaction-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus-circle"
  }), "Option one"), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    'custom-attribute': '783-reporting-page-transaction-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "minus-circle"
  }), "Option two")));
}